import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"

export type UserPermission =
  | "view_platform_overview"
  | "view_transaction_count"
  | "create_merchant"
  | "access_admin"
  | "bulk_unpair_terminals"
  | "unpair_terminal"
  | "view_terminals"
  | "view_users"
  | "manage_users"
  | "manage_notifications"
  | "confirm_terminal"

export type RetrieveCurrentUserResponse = {
  id: string
  email: string
  firstName: string
  lastName: string
  permissions: UserPermission[]
  isSuperuser: boolean
  hasPassword: boolean
}

const retrieveCurrentUser = async () => {
  try {
    const { body } =
      await api.get<RetrieveCurrentUserResponse>("/whoami/")
    return body
  } catch (error) {
    if (error instanceof ApiError && error.status === 401) {
      return null
    } else {
      throw error
    }
  }
}

export const CURRENT_USER_QUERY_KEY = "current_user"
export const useCurrentUser = () => {
  const { data, ...queryReturn } = useQuery({
    queryKey: [CURRENT_USER_QUERY_KEY],
    queryFn: () => retrieveCurrentUser(),
  })

  return {
    currentUser: data,
    ...queryReturn,
  }
}
